import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex: 1;
`;

export const Content = styled.div`
  background-color: ${(props) => props.theme.backgroundLight};
  border-radius: 32px;
  height: 56px;
  display: flex;
  flex: 1;
  padding: 3px;
`;

export const Item = styled.button<{ $active: boolean }>`
  background: none;
  color: ${(props) => props.theme.textDark};
  border-radius: 32px;
  border: none;
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;

  ${(props) =>
    props.$active &&
    css`
      background: ${props.theme.white};
      color: ${props.theme.textDark};
    `}
`;

export const Label = styled.label`
  display: block;
  color: ${(props) => props.theme.textDark};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`;
